import React, { useEffect } from "react";
import { useState } from "react";

import MKTypography from "../../../components/MKTypography";
import colors from "../../../assets/theme/base/colors";
import MDBox from "../../MDBox";
import MKBox from "../../MKBox";
import { Grid } from "@mui/material";

const CapsLockIdentifier = (props) => {
  const { events } = props;
  const [isCapsLockOn, setIsCapsLockOn] = useState(false);

  useEffect(() => {
    if (events != null) {
      if (events.getModifierState("CapsLock")) {
        setIsCapsLockOn(true);
      } else {
        setIsCapsLockOn(false);
      }
    }
  }, [events]);

  return (
    <MKBox
      mb={1}
      sx={({ breakpoints }) => ({
        display: "flex",
        minWidth: "30rem",
        [breakpoints.down("md")]: {
          minWidth: "80vw",
        },
      })}
    >
      {isCapsLockOn && (
        <MKTypography
          variant="h6"
          style={{
            fontFamily: "Barlow",
            color: colors.warning.focus,
            fontWeight: "700",
          }}
        >
          Warning: Caps Lock is ON
        </MKTypography>
      )}
    </MKBox>
  );
};

export default CapsLockIdentifier;
